/**
 *
 * @description  ģ���б�ҳ�Ĳ˵�
 *
 * */

import { useEffect, useRef, useState } from 'react';
import { Dropdown, Menu, message } from 'antd';
import { useLocation } from 'react-router-dom';
import { driver } from 'driver.js';
import { useEventEmitter } from '&/utils/customHooks/useEventEmitter';
import LeftTreeMenu from '@/components/LeftTreeMenu';
import {
    postInspectList,
    postPlanList,
    postNotepadList,
    postExamineList,
} from '&/api/personCenter/templateSettings';
import {
    removeInspect,
    removeNotepad,
    removeExamine,
    removePlan,
    deleteModal,
    indexMap,
} from '&/components/TemplateManagement/common';
import { useStoreState } from '&/utils/customHooks';
import quickStartGuide from '&/store/quickStartGuide';
import EditConstructionTemplateModal from './EditConstructionTemplateModal';
import { deepCopy } from '&/utils/common';
import 'driver.js/dist/driver.css';
import './index.scss';

let timer = null;
let driverObj = null;
export default function TemplateTree(props) {
    const { setLoading } = props;
    const { organization = {} } = useStoreState('appStore');
    const leftTreeMenuRef = useRef();
    const editConstructionTemplateModalRef = useRef();
    const location = useLocation();

    const TEMPLATES_KEY = [
        'constructionTemplate',
        'decorateTemplate',
        'inspectionTemplate',
        'acceptanceTemplate',
    ];

    const baseTreeData = TEMPLATES_KEY.map(key => ({
        key,
        name: intl.get(`templateSettings.${key}`),
        isLeaf: false,
        children: [],
        type: key,
    }));

    const [treeData, setTreeData] = useState([]);
    const [templateData, setTemplateData] = useState({});
    const [editType, setEditType] = useState({});
    const { emit, useListener } = useEventEmitter();

    const queryTreeData = async type => {
        setLoading(true);
        try {
            let data = deepCopy(treeData.length ? treeData : baseTreeData);
            if (type) {
                data[indexMap[type]].children = await getTemplateDataByType(
                    type
                );
            } else {
                const res = await Promise.all(
                    TEMPLATES_KEY.map(key => getTemplateDataByType(key))
                );
                let index = 0;
                for (const arr of res) {
                    data[index++].children = arr;
                }
            }
            setLoading(false); // 必须放在数据更新的前面不然会影响数据更新
            setTreeData(data);
            emit('update-template-list', { list: data });
            return Promise.resolve({ list: data });
        } catch {
            setLoading(false);
        }
    };

    useListener('query-template-list', async ([data]) => {
        const { hideLoading = false } = data;
        const close = !hideLoading && message.loading();
        try {
            const { list } = await queryTreeData(data.templateType);
            data.callback?.(list);
        } finally {
            !hideLoading && close();
        }
    });

    useListener('selected-node', ([node]) => {
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        driverObj && driverObj.destroy();
        driverObj = driver({
            disableActiveInteraction: true,
            allowClose: false,
        });
        if (
            node.key === 'decorateTemplate' ||
            (node.parentKey && node.parentKey === 'decorateTemplate')
        ) {
            const target = document.querySelector('.btn-box .add-btn');
            if (!target) return;
            quickStartGuide
                .queryGuidance('entNotepadTemp')
                .then(entNotepadTemp => {
                    if (+entNotepadTemp !== 0) return;
                    driverObj.setSteps([
                        {
                            element: target,
                            popover: {
                                title: intl.get(
                                    'quickStartGuidance.notePadTemp.title'
                                ),
                                description: intl.get(
                                    'quickStartGuidance.notePadTemp.description'
                                ),
                                side: 'bottom',
                                align: 'end',
                                doneBtnText: intl.get(
                                    'quickStartGuidance.button.done'
                                ),
                                onPopoverRender: dom => {
                                    const { previousButton } = dom;
                                    previousButton.style.display = 'none';
                                },
                                onNextClick: () => {
                                    quickStartGuide.setGuidanceStatus(
                                        'entNotepadTemp',
                                        2
                                    );
                                    driverObj.destroy();
                                },
                            },
                        },
                    ]);
                    driverObj.drive();
                });
        } else if (
            node.key === 'constructionTemplate' ||
            (node.parentKey && node.parentKey === 'constructionTemplate')
        ) {
            quickStartGuide.queryGuidance('entPlanTemp').then(entPlanTemp => {
                if (+entPlanTemp !== 0) return;
                const [dropdownEle] = document.querySelectorAll(
                    '.directory-dropdown'
                );
                if (dropdownEle) {
                    dropdownEle.click();
                } else {
                    return;
                }
                timer = setTimeout(() => {
                    const targetEle = document.querySelector(
                        '.directory-dropdown-overlay'
                    );
                    driverObj.setSteps([
                        {
                            element: targetEle,
                            popover: {
                                title: intl.get(
                                    'quickStartGuidance.PlanTemp.title'
                                ),
                                description: intl.get(
                                    'quickStartGuidance.PlanTemp.description'
                                ),
                                side: 'right',
                                align: 'center',
                                doneBtnText: intl.get(
                                    'quickStartGuidance.button.done'
                                ),
                                onPopoverRender: dom => {
                                    const { previousButton } = dom;
                                    previousButton.style.display = 'none';
                                },
                                onNextClick: () => {
                                    quickStartGuide.setGuidanceStatus(
                                        'entPlanTemp',
                                        2
                                    );
                                    driverObj.destroy();
                                },
                            },
                            onDeselected: () => {
                                dropdownEle && dropdownEle.click();
                            },
                        },
                    ]);
                    driverObj.drive();
                }, 100);
            });
        } else if (
            node.key === 'inspectionTemplate' ||
            (node.parentKey && node.parentKey === 'inspectionTemplate')
        ) {
            const target = document.querySelector('.btn-box .add-btn');
            if (!target) return;
            quickStartGuide
                .queryGuidance('entExamineTemp')
                .then(entExamineTemp => {
                    if (+entExamineTemp !== 0) return;
                    driverObj.setSteps([
                        {
                            element: target,
                            popover: {
                                title: intl.get(
                                    'quickStartGuidance.examineTemp.title'
                                ),
                                description: intl.get(
                                    'quickStartGuidance.examineTemp.description'
                                ),
                                side: 'bottom',
                                align: 'end',
                                doneBtnText: intl.get(
                                    'quickStartGuidance.button.done'
                                ),
                                onPopoverRender: dom => {
                                    const { previousButton } = dom;
                                    previousButton.style.display = 'none';
                                },
                                onNextClick: () => {
                                    quickStartGuide.setGuidanceStatus(
                                        'entExamineTemp',
                                        2
                                    );
                                    driverObj.destroy();
                                },
                            },
                        },
                    ]);
                    driverObj.drive();
                });
        } else if (
            node.key === 'acceptanceTemplate' ||
            (node.parentKey && node.parentKey === 'acceptanceTemplate')
        ) {
            const target = document.querySelector('.btn-box .add-btn');
            if (!target) return;
            quickStartGuide
                .queryGuidance('entInspectTemp')
                .then(entInspectTemp => {
                    if (+entInspectTemp !== 0) return;
                    driverObj.setSteps([
                        {
                            element: target,
                            popover: {
                                title: intl.get(
                                    'quickStartGuidance.inspectTemp.title'
                                ),
                                description: intl.get(
                                    'quickStartGuidance.inspectTemp.description'
                                ),
                                side: 'bottom',
                                align: 'end',
                                doneBtnText: intl.get(
                                    'quickStartGuidance.button.done'
                                ),
                                onPopoverRender: dom => {
                                    const { previousButton } = dom;
                                    previousButton.style.display = 'none';
                                },
                                onNextClick: () => {
                                    quickStartGuide.setGuidanceStatus(
                                        'entInspectTemp',
                                        2
                                    );
                                    driverObj.destroy();
                                },
                            },
                        },
                    ]);
                    driverObj.drive();
                });
        }
    });

    useEffect(queryTreeData, []);

    useEffect(() => {
        if (treeData.length === 0) return;
        const urlSearchParams = new URLSearchParams(location.search);
        const item = urlSearchParams.get('item');
        if (item === 'decorateTemplate') {
            leftTreeMenuRef.current.onSelect(treeData[1].key, {
                node: treeData[1],
            });
        } else if (item === 'inspectionTemplate') {
            leftTreeMenuRef.current.onSelect(treeData[2].key, {
                node: treeData[2],
            });
        } else if (item === 'acceptanceTemplate') {
            leftTreeMenuRef.current.onSelect(treeData[3].key, {
                node: treeData[3],
            });
        } else {
            quickStartGuide.queryGuidance('entPlanTemp').then(entPlanTemp => {
                if (+entPlanTemp !== 0) return;
                timer = setTimeout(() => {
                    const [dropdownEle] = document.querySelectorAll(
                        '.directory-dropdown'
                    );
                    if (dropdownEle) {
                        dropdownEle.click();
                    } else {
                        clearTimeout(timer);
                        timer = null;
                        return;
                    }
                    timer = setTimeout(() => {
                        const targetEle = document.querySelector(
                            '.directory-dropdown-overlay'
                        );
                        driverObj && driverObj.destroy();
                        driverObj = driver({
                            disableActiveInteraction: true,
                            allowClose: false,
                            steps: [
                                {
                                    element: targetEle,
                                    popover: {
                                        title: intl.get(
                                            'quickStartGuidance.PlanTemp.title'
                                        ),
                                        description: intl.get(
                                            'quickStartGuidance.PlanTemp.description'
                                        ),
                                        side: 'right',
                                        align: 'center',
                                        doneBtnText: intl.get(
                                            'quickStartGuidance.button.done'
                                        ),
                                        onPopoverRender: dom => {
                                            const { previousButton } = dom;
                                            previousButton.style.display =
                                                'none';
                                        },
                                        onNextClick: () => {
                                            quickStartGuide.setGuidanceStatus(
                                                'entPlanTemp',
                                                2
                                            );
                                            driverObj.destroy();
                                        },
                                    },
                                },
                            ],
                        });
                        driverObj.drive();
                    }, 500);
                }, 500);
            });
        }

        return () => {
            if (timer) {
                clearTimeout(timer);
                timer = null;
            }
            if (driverObj) {
                driverObj.destroy();
                driverObj = null;
            }
        };
    }, [treeData]);

    async function getTemplateDataByType(type) {
        try {
            let res = {};
            let nameKey = '';
            switch (type) {
                case 'acceptanceTemplate':
                    res = await postInspectList();
                    nameKey = 'stage';
                    break;
                case 'constructionTemplate':
                    res = await postPlanList();
                    nameKey = 'name';
                    break;
                case 'decorateTemplate':
                    res = await postNotepadList();
                    nameKey = 'title';
                    break;
                case 'inspectionTemplate':
                    res = await postExamineList();
                    nameKey = 'title';
                    break;
                default:
            }
            return res.data.map(item => {
                return {
                    originalItem: item,
                    id: item.id,
                    name: item[nameKey],
                    key: `${type}-${item.id}`,
                    isLeaf: true,
                    type,
                    parentName: intl.get(`templateSettings.${type}`),
                };
            });
        } catch (e) {}
    }

    const selectNode = (keys, data) => {
        const { node } = data;
        emit('selected-template-node', { ...node, treeData });
    };

    const onEdit = (nodeData, type) => {
        setTemplateData(nodeData);
        setEditType(type);
        editConstructionTemplateModalRef.current.show();
    };
    const onDelete = async (nodeData, e) => {
        try {
            const removeTemplateTypeMap = {
                inspectionTemplate: removeExamine,
                acceptanceTemplate: removeInspect,
                constructionTemplate: removePlan,
                decorateTemplate: removeNotepad,
            };
            await removeTemplateTypeMap[nodeData.type](nodeData);
            queryTreeData();
        } catch (e) {}
    };

    const titleMenu = nodeData => (
        <Menu>
            {nodeData.type === 'constructionTemplate' && (
                <>
                    <Menu.Item key="1" onClick={e => onEdit(nodeData, 'edit')}>
                        {intl.get('templateSettings.editConstructionTemplate')}
                    </Menu.Item>
                    <Menu.Item key="3" onClick={e => onEdit(nodeData, 'copy')}>
                        {intl.get('templateSettings.copyTemplate')}
                    </Menu.Item>
                </>
            )}
            <Menu.Item
                key="2"
                onClick={e => {
                    deleteModal(
                        () => {
                            onDelete(nodeData, e);
                        },
                        {
                            content: intl.get(
                                'templateSettings.templateDeleteWarning'
                            ),
                        }
                    );
                }}>
                {intl.get('base.delete')}
            </Menu.Item>
        </Menu>
    );
    const nodeMenu = nodeData =>
        nodeData.isLeaf &&
        organization.roleFlag === 'admin' &&
        nodeData?.originalItem?.type !== '1' && (
            <Dropdown
                overlayClassName="directory-dropdown-overlay"
                overlay={titleMenu(nodeData)}
                trigger={['click']}
                destroyPopupOnHide={true}
                className="directory-dropdown">
                <i
                    className="icon-more-h filled node__more-menu"
                    onClick={leftTreeMenuRef.current.handleMore}></i>
            </Dropdown>
        );

    const getResetTreeKey = (list, type, selectData) => {
        let key = list[0].key;
        list.forEach(item => {
            if (item.key === selectData.parentKey) {
                if (item?.children?.length) {
                    key = item.children[0].key;
                } else {
                    key = item.key;
                }
            }
        });
        return [key];
    };

    const resetSelectId = list => {
        const constructionData = list[0];
        const data =
            constructionData.children[constructionData.children.length - 1];
        const treeData = {
            node: {
                id: data.id,
                key: data.key,
                name: data.name,
                originalItem: data.originalItem,
                parentKey: data.type,
                parentName: data.parentName,
                type: 'constructionTemplate',
                isLeaf: false,
                treeData: list,
                value: data.name,
            },
        };
        leftTreeMenuRef.current.onSelect('', treeData);
    };

    const menuOpt = {
        menuTitle: intl.get('templateSettings.template'),
        selectNode,
        nodeMenu,
    };

    return (
        <div className="template-settings">
            <LeftTreeMenu
                ref={leftTreeMenuRef}
                treeMenuData={treeData}
                menuOpt={menuOpt}
                getResetTreeKey={getResetTreeKey}
            />
            <EditConstructionTemplateModal
                type={editType}
                templateData={templateData}
                showEditModal={resetSelectId}
                ref={editConstructionTemplateModalRef}
            />
        </div>
    );
}
